import { WA_MESSAGES } from "@/config/business";
import { WhatsAppButton } from "./CtaButtons";

const OfferSection = () => (
  <section id="offer" className="scroll-mt-24 py-16 sm:py-20">
    <div className="mx-auto max-w-6xl px-4 sm:px-8">
      <div className="relative overflow-hidden rounded-3xl border border-[#C5A059]/25 bg-[#1C1917] px-6 py-14 text-center shadow-2xl sm:px-14 sm:py-16">
        <div
          className="pointer-events-none absolute -top-32 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-[#C5A059]/20 blur-3xl"
          aria-hidden="true"
        />
        <div
          className="pointer-events-none absolute -bottom-40 -right-20 h-80 w-80 rounded-full bg-[#C5A059]/10 blur-3xl"
          aria-hidden="true"
        />
        <div className="relative">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#EED8A1]">
            New Spa Opening Offer
          </p>
          <p
            data-testid="offer-section-headline"
            className="mt-4 font-serif text-5xl font-semibold tracking-tight text-[#EED8A1] sm:text-6xl lg:text-7xl"
          >
            FLAT 20% OFF
          </p>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-stone-300 sm:text-base">
            Celebrate the opening of GK Wellness &amp; Luxury Spa with our special introductory
            offer.
          </p>
          <div className="mt-8">
            <WhatsAppButton
              message={WA_MESSAGES.offer}
              label="Claim Your 20% OFF"
              testId="offer-section-claim-cta"
              size="lg"
            />
          </div>
          <p className="mt-4 text-xs text-stone-400 sm:text-sm">
            Book your appointment through WhatsApp.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default OfferSection;
